document.addEventListener("DOMContentLoaded", () => {


    if (!customElements.get('cart-popup-items')) {
        class CartPopupItems extends HTMLElement {
            constructor() {
                super();
                this.lineItemStatusElement =
                    document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');
                const debouncedOnChange = debounce((event) => {
                    this.onChange(event);
                }, ON_CHANGE_DEBOUNCE_TIMER);
                this.addEventListener('change', debouncedOnChange.bind(this));
                let mcCart = document.querySelector('#mc-cart-hg.mc-cart-hg-custom')
                mcCart.replaceWith(mcCart.cloneNode(true));
                document.querySelector('#mc-cart-hg.mc-cart-hg-custom').addEventListener('click', (e) => {
                    e.stopPropagation();
                    if (!$(this).hasClass('active')) {
                        $('body').addClass('mc-open');
                        $(this).addClass('active');

                        let $h_mc_n;
                        $h_mc_n = $('header').height() + $('.m-cart-hg-custom #m-cart-hg .cart-hg-btns ').height() + ($('.m-cart-hg-custom #m-cart-hg .sp-mc').height() * 2);
                        let $h_mc;
                        $h_mc = $(window).innerHeight() - $h_mc_n;
                        $('.m-cart-hg-custom #m-cart-hg .cart-items-grid').css('max-height', $h_mc);

                    } else {
                        // $(this).removeClass('active');
                        // document.querySelector('.mc-cart-hg-custom').classList.remove('active')
                        // $('body').removeClass('mc-open');
                    }
                    this.renderCartPopup();
                })

            }

            onChange(event) {
                if (document.querySelector('.m-cart-hg-custom') !== null) {
                    document.querySelector('.m-cart-hg-custom').classList.add('loading');
                }
                this.updateQuantity(event.target.dataset.index, event.target.value);
            }
            updateQuantity(line, quantity, name) {
                const body = JSON.stringify({
                    line,
                    quantity,
                });
                fetch(`${routes.cart_change_url}`, {
                    ...fetchConfig(),
                    ...{
                        body
                    }
                })
                    .then((response) => {
                        return response.text();
                    })
                    .then((state) => {
                        const parsedState = JSON.parse(state);
                        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
                        const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
                        let message = '';
                        const items = document.querySelectorAll('.cart-item');
                        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
                            if (typeof updatedValue === 'undefined') {
                                message = window.cartStrings.error;
                            } else {
                                message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
                            }
                        }


                        if (parsedState.item_count === 0) {
                            $('#m-cart-hg').addClass('emp_car');
                        } else {
                            $('#m-cart-hg').removeClass('emp_car');
                        }



                    })
                    .finally(() => {
                        this.renderCartPopup();

                    });
            }

            renderCartPopup() {

                let _this = this;
                let url = this.dataset.url
                fetch(`${url}`)
                    .then((response) => response.text())
                    .then((responseText) => {
                        const html = new DOMParser().parseFromString(responseText, 'text/html');

                        if (html.querySelector('.products-wrapper') != null && document.querySelector('.products-wrapper')) {
                            const fetchProducts = html.querySelector('.products-wrapper');
                            let products = document.querySelector('.products-wrapper');
                            products.innerHTML = fetchProducts.innerHTML;
                        }

                        if (html.querySelector('#cart-recommended-products') != null && document.querySelector('#cart-recommended-products') != null) {
                            const fetchProductsRecommended = html.querySelector('#cart-recommended-products');
                            let productsRecommended = document.querySelector('#cart-recommended-products');
                            fetchProductsRecommended.innerHTML = productsRecommended.innerHTML;
                            productsRecommended.querySelectorAll('#hg-buy-btn').forEach(function(item) {
                                item.addEventListener('click', function(e) {
                                    if (document.querySelector('.m-cart-hg-custom') !== null) {
                                        document.querySelector('.m-cart-hg-custom').classList.add('loading');
                                    }
                                    let id = e.target.closest('#hg-buy-btn').dataset.id;
                                    _this.addToCart(id);
                                })
                            })

                        }

                        if (html.querySelector('.cart__footer-wrapper') != null && document.querySelector('.cart__footer-wrapper') != null) {
                            const fetchCheckoutButt = html.querySelector('.cart__footer-wrapper');
                            let checkoutButt = document.querySelector('.cart__footer-wrapper');
                            checkoutButt.innerHTML = fetchCheckoutButt.innerHTML;
                        }

                        let cartItem_count = html.querySelector('#m-cart-hg').dataset.count;

                        if (cartItem_count == 0) {
                            document.querySelector('.mc-cart-hg-custom').classList.add('emp_c');
                            document.querySelector('.mc-cart-hg-custom > span').classList.add('hg-h');
                        } else {
                            document.querySelector('.mc-cart-hg-custom').classList.remove('emp_c');
                            document.querySelector('.mc-cart-hg-custom > span').classList.remove('hg-h');
                            document.querySelector('.mc-cart-hg-custom > span').textContent = cartItem_count;
                        }

                        // let currCode = document.querySelector('.etranslate-currency-list-button .etranslate-currency-name').textContent;
                        // if (currCode != 'EUR') {
                        //     if (currCode == 'UAH') {
                        //         document.querySelector(`.etranslate-selector-dropdown-item[data-code="USD"]`).click();
                        //         document.querySelector(`.etranslate-selector-dropdown-item[data-code="UAH"]`).click();
                        //     } else {
                        //         document.querySelector(`.etranslate-selector-dropdown-item[data-code="UAH"]`).click();
                        //         document.querySelector(`.etranslate-selector-dropdown-item[data-code="USD"]`).click();
                        //     }
                        // }


                        if (document.querySelector('.m-cart-hg-custom') !== null) {
                            document.querySelector('.m-cart-hg-custom').classList.remove('loading');
                        }

                    })
                    .catch((e) => {
                        console.error(e);
                    });
            }
            updateLiveRegions(line, message) {
                const lineItemError =
                    document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
                if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

                this.lineItemStatusElement.setAttribute('aria-hidden', true);

                const cartStatus =
                    document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
                cartStatus.setAttribute('aria-hidden', false);

                setTimeout(() => {
                    cartStatus.setAttribute('aria-hidden', true);
                }, 1000);
            }

            addToCart(id) {
                $.ajax({
                    type: 'POST',
                    url: '/cart/add.js',
                    data: {
                        quantity: 1,
                        id: id,
                    },
                    dataType: 'json',
                    success: function(data) {
                        $('#hg-buy-btn').addClass('adding-hg');
                        $('#mc-cart-hg').removeClass('emp_c');
                        $('#mc-cart-hg').removeClass('emp_c');
                        $('#mc-cart-hg.mc-cart-hg-custom').trigger('click');
                        $('#m-cart-hg').removeClass('emp_car');

                    },
                    error: function(data) {
                        alert(data.responseJSON.description)
                    }
                });
            }
        }

        customElements.define('cart-popup-items', CartPopupItems);
    }
    document.querySelector('.close-mc-custom').addEventListener('click', function() {
        document.querySelector('.mc-cart-hg-custom').classList.remove('active')
        $('body').removeClass('mc-open');
    })
})

if (!customElements.get('cart-popup-remove-button')) {
    class CartPopupRemoveButton extends HTMLElement {
        constructor() {
            super();
            this.addEventListener('click', (event) => {
                event.preventDefault();
                if (document.querySelector('.m-cart-hg-custom') !== null) {
                    document.querySelector('.m-cart-hg-custom').classList.add('loading');
                }
                const cartItems = this.closest('cart-popup-items') || this.closest('cart-drawer-items');
                cartItems.updateQuantity(this.dataset.index, 0);
            });
        }
    }

    customElements.define('cart-popup-remove-button', CartPopupRemoveButton);
}
